// ============================================================================
// REPOSITORY: FinancialLedgerRepository — Acesso Firestore para financial_ledger
// ARQUIVO: src/services/FinancialLedgerRepository.js
// ============================================================================

import { collection, query, orderBy, where, onSnapshot } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';

export function subscribeFinancialLedger(appId, onData, onError) {
  const col = collection(db, ...FS.financialLedger(appId));
  const q = query(col, where('isDeleted', '!=', true), orderBy('isDeleted'), orderBy('createdAt', 'desc'));

  return onSnapshot(q, onData, (e) => {
    const col2 = collection(db, ...FS.financialLedger(appId));
    const q2 = query(col2, orderBy('createdAt', 'desc'));
    onSnapshot(q2, onData, onError);
  });
}
